import { defineSlotRecipe } from '@chakra-ui/react';

const containerStyle = {
    justifyContent: 'space-between',
    alignItems: 'center',
    bg: 'white',
    borderRadius: 'md',
    p: 4,
    w: 'full',
};

export const searchEngineMobileSlotRecipe = defineSlotRecipe({
    slots: [
        'container',
        'listingSearchContainer',
        'mapSearchContainer',
        'subdomainSearchContainer',
        'datesWrapper',
        'icon',
    ],
    base: {
        container: {
            ...containerStyle,
            borderTopRadius: 'md',
            borderBottomRadius: 0,
        },
        mapSearchContainer: {
            ...containerStyle,
            py: 2.5,
            boxShadow: 'searchBar',
        },
        listingSearchContainer: {
            ...containerStyle,
            border: '1px solid',
            borderColor: 'gray.300',
            py: 2,
        },
        subdomainSearchContainer: {
            ...containerStyle,
            boxShadow: 'tile',
            borderRadius: 'md',
        },
        datesWrapper: {
            alignItems: 'center',
            _after: {
                content: {
                    base: '"\u2022"',
                    md: 'none',
                },
                ml: 2,
                mt: -0.5,
                transform: 'scale(1.25)',
            },
        },
        icon: {
            color: 'secondary.500',
        },
    },
});
